import React from 'react';
import classes from './SelectedPackageCard.module.css';
import LabeledText from '../LabeledText';
import CommonCard from '../CommonCard';
import { calculateRemainingDays } from '../../../Helpers';
const SelectedPackageCard = ({ data }) => {
  return (
    <CommonCard className={classes.selectedCard}>
      <LabeledText
        label={data?.subscriptionNote}
        value={`${calculateRemainingDays(data?.subscriptionEndDate)} Days`}
        className={classes.selectedPackageWrapper}
      />
      <LabeledText
        className={classes.selectedSmsWrapper}
        label={`${data?.subscriptionNote}`}
        value={`${data?.assignedNoOfSMS} SMS`}
      />
      <span className={classes.renewPackageLink}>Renew Package</span>
    </CommonCard>
  );
};

export default SelectedPackageCard;
